<template>
  <v-row class="mb-8">
    <v-col cols="12">
      <v-sheet
        v-if="!loading"
        outlined>
        <v-col class="pa-4 mb-8">
          <v-lazy
            :options="{
              threshold: .5
            }"
            min-height="200"
            transition="fade-transition">

            <showIdeaProjectsStand 
              v-if="entrepreneurship.type_postulations_id===1" 
              :data="data" />
    
            <showIdeaProjectsSchoolsStand 
              v-if="entrepreneurship.type_postulations_id===2" 
              :data="data" />
    
            <showBusinessModelsStand
              v-if="entrepreneurship.type_postulations_id===3" 
              :data="data" />
          </v-lazy>
        </v-col>
      </v-sheet>
    </v-col>
    
    <v-col cols="12" class="d-sm-flex">
      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        depressed
        color="#0097B4"
        dark
        class="mr-2 mt-2 white--text"
        :to="{ name: 'ProjectGallery'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>

      <v-spacer />

      <v-btn
        :block="$vuetify.breakpoint.xsOnly"
        depressed
        color="#0097B4"
        dark
        class="mr-2 mt-2 white--text"
        @click="getOtherEntrepreneurship()"
        >
        Ver otro
        <v-icon right>
          mdi-arrow-right
        </v-icon>
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API
  import showIdeaProjectsStand from '@/components/stand/showIdeaProjectsStand.vue'
  import showIdeaProjectsSchoolsStand from '@/components/stand/showIdeaProjectsSchoolsStand.vue'
  import showBusinessModelsStand from '@/components/stand/showBusinessModelsStand.vue'

  export default {
    name: 'showProject',
    components: {
      showIdeaProjectsStand,
      showIdeaProjectsSchoolsStand,
      showBusinessModelsStand
    },
    data: () => ({
      loading_download:false,
      loading:true,
      slug:'',
      show: false,
      data:[],
      entrepreneurship:[]
    }),
    computed: {
      ...mapGetters([
        'edition'
      ])
    },
    methods:{
      async getEntrepreneurship(){
        await axios.get('participant/entrepreneurship-windows/'+this.slug).then(response =>{
          this.data = response.data.data
          this.entrepreneurship = response.data.data.window
        }).catch(error => {
          console.log(error);
        })
      },

      async getOtherEntrepreneurship(){
        this.loading = true
        let old_slug = this.entrepreneurship.next_stand
        await axios.get('participant/entrepreneurship-windows/'+this.entrepreneurship.next_stand).then(response =>{
          this.data = response.data.data
          this.entrepreneurship = response.data.data.window
          this.$router.replace({name: 'showProject', params: { slug: old_slug }})
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      async downloadPDF(){
        this.loading_download=true
        this.url = VUE_URL_API + '/entrepreneurship-windows/'+this.slug+'/generate-pdf'
        await axios.get(
          this.url, 
          {responseType: 'blob'}
        ).then((response) => {
          const content = response.headers['content-type'];
          download(response.data,  this.entrepreneurship.title , content)
          this.loading_download=false
        })
      },

      handleEdition(){
        if(this.edition.edition.waiting_room){
          this.loading = false
          this.$router.push({ name: 'home' })
        }
      }
    },

    created(){
      this.slug = this.$route.params.slug;
      Promise.all([
        this.handleEdition(),
        this.getEntrepreneurship()
      ]).then(() => {
        this.loading=false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style scoped>
.images {
  position: fixed;
}

.centered {
  position: absolute;
  top: 35vh;
  left: 10%;
  right:10%;
  transform: translate(0%, -80%);
}

.image-landing{
	position: relative;
	max-width: 100vw;
  height: 30vh;
	width: 100%;
  border-bottom: 5px solid #00a1b8;
}
</style>